module.exports = __webpack_public_path__ + "img/active.cf585ee2.png";